import { render, staticRenderFns } from "./Clinics.vue?vue&type=template&id=35c6e966&scoped=true&"
import script from "./Clinics.vue?vue&type=script&lang=js&"
export * from "./Clinics.vue?vue&type=script&lang=js&"
import style0 from "./Clinics.vue?vue&type=style&index=0&id=35c6e966&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "35c6e966",
  null
  
)

export default component.exports